var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcessandServices1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10265_14866)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.667 18.7569C14.667 18.335 14.8426 17.9303 15.1551 17.632C15.4677 17.3336 15.8916 17.166 16.3337 17.166H29.667C30.109 17.166 30.5329 17.3336 30.8455 17.632C31.1581 17.9303 31.3337 18.335 31.3337 18.7569V27.2418C31.3337 27.6637 31.1581 28.0684 30.8455 28.3667C30.5329 28.6651 30.109 28.8327 29.667 28.8327H16.3337C15.8916 28.8327 15.4677 28.6651 15.1551 28.3667C14.8426 28.0684 14.667 27.6637 14.667 27.2418V18.7569ZM18.0003 21.4084C18.0003 20.8459 18.2345 20.3063 18.6512 19.9085C19.0679 19.5107 19.6332 19.2872 20.2225 19.2872C20.8119 19.2872 21.3771 19.5107 21.7939 19.9085C22.2106 20.3063 22.4448 20.8459 22.4448 21.4084C22.4448 21.971 22.2106 22.5106 21.7939 22.9084C21.3771 23.3062 20.8119 23.5297 20.2225 23.5297C19.6332 23.5297 19.0679 23.3062 18.6512 22.9084C18.2345 22.5106 18.0003 21.971 18.0003 21.4084ZM28.0003 21.4084H24.667V20.3478H28.0003V21.4084ZM28.0003 24.5903H24.667V23.5297H28.0003V24.5903ZM20.2225 24.5903C19.6187 24.5906 19.0268 24.7513 18.5131 25.0544C17.9993 25.3574 17.5841 25.7909 17.3137 26.3063L16.947 27.0042C16.9045 27.0851 16.8844 27.1751 16.8887 27.2655C16.8929 27.356 16.9214 27.4438 16.9713 27.5208C17.0212 27.5978 17.0909 27.6613 17.1738 27.7053C17.2566 27.7493 17.3499 27.7723 17.4448 27.7721H23.0003C23.0951 27.7721 23.1882 27.7489 23.271 27.7049C23.3537 27.6608 23.4233 27.5973 23.473 27.5204C23.5228 27.4434 23.5511 27.3556 23.5553 27.2653C23.5595 27.1749 23.5394 27.085 23.497 27.0042L23.1314 26.3063C22.861 25.7909 22.4457 25.3574 21.932 25.0544C21.4183 24.7513 20.8264 24.5906 20.2225 24.5903Z",
    fill: "#013C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0801 24.6328H24.5439V23.4609H28.0801V24.6328ZM28.0801 21.5059H24.5439V20.334H28.0801V21.5059Z",
    fill: "#F6948B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10265_14866",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10265_14866"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10265_14866",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessandServices1);
export default __webpack_public_path__ + "static/media/Process and Services 1.d5f4f4c3f5552cf0a90cce846197c019.svg";
export { ForwardRef as ReactComponent };